import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule, APP_INITIALIZER } from '@angular/core';
import { Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { AuthService } from '@iqd/shared-quoting';
import { SharedUtilsModule } from '@iqd/shared-utils';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BudgetModule } from './budget/budget.module';
import { AuthService as BudgetAuthService } from './core/auth.service';
import { CoreModule } from './core/core.module';
import { SettingsEffects } from './effects/settings';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { settingsReducer, SettingsState } from './reducers/settings';

Sentry.init({
  dsn: environment.sentry.dsn,
  release: environment.version,
  environment: environment.sentry.environment,
  enabled: environment.production,
  sendDefaultPii: true,
});

export interface AppState {
  settings: SettingsState;
}

export const reducers: ActionReducerMap<AppState> = {
  settings: settingsReducer,
};

@NgModule({
  declarations: [AppComponent, PageNotFoundComponent],
  imports: [
    SharedUtilsModule,
    BrowserModule,
    HttpClientModule,
    CoreModule,
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    EffectsModule.forRoot([SettingsEffects]),
    !environment.production
      ? StoreDevtoolsModule.instrument({ maxAge: 50 })
      : [],
    AppRoutingModule,
    NgbModule,
    BudgetModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: AuthService, useClass: BudgetAuthService },
    { provide: 'googleTagManagerId', useValue: 'GTM-PT7MKXQ' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
